import React, { useState } from "react";
import { apiFetch } from "../utils/api";
import Button from "../components/ui/Button";
import Input from "../components/ui/Input";
import AuthLayout from "../components/AuthLayout";
import { IconWarning } from "../components/ui/icons";

export default function LoginForm({ onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      const response = await apiFetch("/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setErrorMsg("Server je vratio nevalidan odgovor.");
        return;
      }

      if (data.success) {
        onLoginSuccess(data);
      } else {
        setErrorMsg(data.error || "Nepoznata greška prilikom prijave.");
      }
    } catch {
      setErrorMsg("Neuspešna konekcija sa serverom.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <form onSubmit={handleLogin} className="flex flex-col gap-4" noValidate>
        <div>
          <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-50">Prijava</h1>
          <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">Izveštaji i pregled poslovanja</p>
        </div>

        <Input
          label="Korisničko ime"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          autoFocus
        />
        <Input
          label="Lozinka"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        {errorMsg && (
          <p
            role="alert"
            className="flex items-start gap-2 rounded-md border border-danger/30 bg-danger/5 px-3 py-2 text-sm text-danger-dark dark:text-danger-light"
          >
            <IconWarning aria-hidden="true" className="mt-0.5 shrink-0 text-base" />
            {errorMsg}
          </p>
        )}

        <Button type="submit" disabled={loading} className="mt-1 w-full">
          {loading ? "Prijavljivanje..." : "Prijavi se"}
        </Button>
      </form>
    </AuthLayout>
  );
}
